export default __webpack_public_path__ + "static/media/A8021AB2-E669-48BF-A6B2-9472B9CABCA3_1_105_c.cc3715e1.jpeg";